<main class="recuperar_senha">
  <section class="recuperar_senha__section">
    <div class="recuperar_senha__section__logo"></div>
    <form class="recuperar_senha__section__form" [formGroup]="loginForm" *ngIf="!isSubmitting && !isSubmitted && !hasError">
      <h1 class="recuperar_senha__section__form__title">Esqueceu sua senha?</h1>
      <p class="recuperar_senha__section__form__subtitle">
        Digite seu CPF, CNPJ ou E-mail para iniciar o processo de recuperação de
        senha.
      </p>

      <mat-form-field
        class="recuperar_senha__section__form__input"
        appearance="outline">
        <mat-label>Selecione o tipo de login</mat-label>
        <mat-select (selectionChange)="changeLoginType($event.value)">
          <mat-option *ngFor="let loginType of loginTypes" [value]="loginType">
            {{ loginType.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="recuperar_senha__section__form__input"
        appearance="outline"
        *ngIf="currentLoginType">
        <mat-label>{{ currentLoginType.label }}</mat-label>
        <mat-icon matPrefix class="recuperar_senha__section__form__input__icon">
          {{ currentLoginType.icon }}
        </mat-icon>
        <input
          matInput
          formControlName="login"
          type="{{ currentLoginType.type }}"
          mask="{{ currentLoginType.mask }}"
          required />
      </mat-form-field>

      <button
        class="recuperar_senha__section__form__button"
        type="submit"
        mat-raised-button
        [disabled]="!loginForm.valid"
        (click)="submit()">
        Recuperar senha
      </button>
    </form>

    <app-spinner-animation *ngIf="isSubmitting" />

    <app-confirm-animation *ngIf="isSubmitted" />

    <p class="recuperar_senha__section__message" *ngIf="isSubmitted">
      Um e-mail foi enviado para o endereço cadastrado com as instruções para
      recuperação de senha.
    </p>

    <app-error-animation *ngIf="hasError" />

    <p class="recuperar_senha__section__error" *ngIf="hasError">
      Ocorreu um erro no processo de recuperação de senha. Verifique se o usuário inserido está correto e tente novamente.
    </p>

    <a class="recuperar_senha__section__link" routerLink=".." *ngIf="!isSubmitting">
      Voltar para o login
    </a>
  </section>
</main>
